import { Box, BoxProps, Grid, Typography } from '@mui/material';
import { ComponentType, ReactNode } from 'react';
import { BaseLayout } from 'src/layouts/base-layout';

interface PageProps {
  title?: string;
  children?: any;
  layout?: 'base' | 'empty';
  topButton?: ReactNode;
}

export const Page: ComponentType<PageProps & BoxProps> = ({
  title,
  children,
  layout = 'base',
  topButton,
  ...boxProps
}) => {
  const content = (
    <Box p={4} {...boxProps}>
      <Grid container justifyContent="space-between" alignItems="center" mb={3}>
        <Grid item>{title && <Typography variant="h1">{title}</Typography>}</Grid>
        {topButton && <Grid item>{topButton}</Grid>}
      </Grid>
      {children}
    </Box>
  );
  return layout === 'empty' ? (
    <Box minHeight="100vh" bgcolor="background.default">
      {content}
    </Box>
  ) : (
    <BaseLayout>{content}</BaseLayout>
  );
};
